import axios from 'axios';
import { apiUrl } from './apiUrl';
axios.defaults.headers.common['Authorization'] = localStorage.getItem('loginToken') || '';

export const get = (search, size, page, from, to) =>
    axios.get(`${apiUrl}/order`, { params: { size, page, from, to, search } })

export const create = order =>
    axios.post(`${apiUrl}/order`, order)

export const invoice = order => 
    axios.put(`${apiUrl}/invoiceOrder/${order._id}`)


// WEBPACK FOOTER //
// ./src/baseparking-api/Orders.js